import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ThemeProvider, useAuth, useTheme } from "@/context/AppContext";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Connections from "@/pages/Connections";
import DeviceDetail from "@/pages/DeviceDetail";
import Explorer from "@/pages/Explorer";
import Mapping from "@/pages/Mapping";
import Audit from "@/pages/Audit";
import Setup from "@/pages/Setup";
import Overview from "@/pages/Overview";
import LiveView from "@/pages/LiveView";
import Analytics from "@/pages/Analytics";
import Incidents from "@/pages/Incidents";
import Forecast from "@/pages/Forecast";
import RadarHealth from "@/pages/RadarHealth";
import Reports from "@/pages/Reports";
import Alerts from "@/pages/Alerts";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-5 w-5 animate-spin text-muted-foreground" /></div>;
  }
  return user ? children : <Navigate to="/login" replace />;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  return user?.role === "admin" ? children : <Navigate to="/overview" replace />;
}

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster theme={theme} position="bottom-right" richColors />;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route path="/overview" element={<Overview />} />
              <Route path="/live" element={<LiveView />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/incidents" element={<Incidents />} />
              <Route path="/forecast" element={<Forecast />} />
              <Route path="/radar-health" element={<RadarHealth />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/alerts" element={<Alerts />} />
              <Route path="/settings" element={<AdminOnly><Settings /></AdminOnly>} />
              <Route path="/connections" element={<AdminOnly><Connections /></AdminOnly>} />
              <Route path="/connections/:id" element={<AdminOnly><DeviceDetail /></AdminOnly>} />
              <Route path="/explorer" element={<AdminOnly><Explorer /></AdminOnly>} />
              <Route path="/mapping" element={<AdminOnly><Mapping /></AdminOnly>} />
              <Route path="/audit" element={<AdminOnly><Audit /></AdminOnly>} />
              <Route path="/setup" element={<AdminOnly><Setup /></AdminOnly>} />
            </Route>
            <Route path="*" element={<Navigate to="/overview" replace />} />
          </Routes>
        </BrowserRouter>
        <ThemedToaster />
      </AuthProvider>
    </ThemeProvider>
  );
}
